import Vue from 'vue'
import VueI18n from 'vue-i18n'
import fr from './fr'

Vue.use(VueI18n)

const messages = {
  fr
}

// Create VueI18n instance with options

export default new VueI18n({
  locale: 'fr', // set locale
  messages // set locale messages
})



// WEBPACK FOOTER //
// ./src/locales/index.js